import React, {Component} from 'react'

import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'

import { Field } from 'react-final-form'

import MarkdownEditor from '@ui/MarkdownEditor/Index'
import TextField from '@ui/Fields/TextField'

import styles from '@theme/styles/forms'

const Form = ({
  handleSubmit,
  classes,
  title,
  tenantId,
  model,
  o
}) =>
  <form className={classes.form} onSubmit={handleSubmit} data-testid='terms-form'>
    <Paper className={classes.form__wrapper} elevation={0}>
      <header className={classes.form__header}>
        <Typography component='h2' variant='h5'>
          {title}
        </Typography>
      </header>
      <main className={classes.form__fields}>
        <div className={classes.form__field__wrapper}>
          <Field
            component={TextField}
            className={classes.form__fieldWithError}
            margin='normal'
            fullWidth
            InputLabelProps={{ shrink: true }}
            variant='outlined'
            label={I18n.t('v4/terms.fields.name')}
            name='name'
            required
          />
        </div>
        <div className={classes.form__field__wrapper}>
          <Field
            component={MarkdownEditor}
            className={classes.form__fieldWithError}
            margin='normal'
            fullWidth
            InputLabelProps={{ shrink: true }}
            variant='outlined'
            label={I18n.t('v4/terms.fields.description_pt')}
            name='description_pt'
            readOnly={model.activated_at !== undefined}
            required
          />
        </div>

        <div className={classes.form__field__wrapper}>
          <Field
            component={MarkdownEditor}
            className={classes.form__fieldWithError}
            margin='normal'
            fullWidth
            InputLabelProps={{ shrink: true }}
            variant='outlined'
            label={I18n.t('v4/terms.fields.description_en')}
            name='description_en'
            readOnly={model.activated_at !== undefined}
            required
          />
        </div>

        <div className={classes.form__field__wrapper}>
          <Field
            component={MarkdownEditor}
            className={classes.form__fieldWithError}
            margin='normal'
            fullWidth
            InputLabelProps={{ shrink: true }}
            variant='outlined'
            label={I18n.t('v4/terms.fields.description_es')}
            name='description_es'
            readOnly={model.activated_at !== undefined}
            required
          />
        </div>
      </main>
      <footer className={classes.form__actions}>
        <Button
          className={classes.form__action}
          color='primary'
          type='submit'
          variant='contained'
        >
          {title}
        </Button>

        <Button
          className={classes.form__action}
          color='secondary'
          href={`/v4/o/${o}/admin/tenants/${tenantId}/terms`}
        >
          {I18n.t('actions.back')}
        </Button>
      </footer>
    </Paper>
  </form>

export default withStyles(styles)(Form)
